import React from 'react';
import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';

import Utility from '../../../../util/utilityfunctions';

import OutputText from '@ey/canvascoreservices/OutputText';

import Button from '../../../CoreWrappers/Button';
import Tooltip from '../../../CoreWrappers/Tooltip';
import StyledLinkTooltip from './StyledLinkTooltip';

const LinkTooltip = ({btnLabel, tooltipLabel, linkTo, variant, adobeTrack}) => {
	const history = useHistory();

	const handleOnClick = () => {
		const url = `${window.location.origin}${window.location.pathname}`;
		history.push({pathname: linkTo, state: {prevUrl: url}});

		// Adobe Analytics Click Action
		if (adobeTrack) {
			adobeTrack();
		}
	};

	const renderTrigger = () => {
		const props = {
			variant,
			onClick: handleOnClick,
			label: btnLabel,
			size: 'medium'
		};

		return <Button {...props} />;
	};

	const props = {
		trigger: renderTrigger(),
		placement: 'bottom',
		hideCloseButton: true,
		allowClick: false
	};

	return (
		<Tooltip {...props}>
			<StyledLinkTooltip>
				<OutputText body3>
					{Utility.createRichTextElement(tooltipLabel)}
				</OutputText>
			</StyledLinkTooltip>
		</Tooltip>
	);
};

LinkTooltip.propTypes = {
	btnLabel: PropTypes.string,
	tooltipLabel: PropTypes.string,
	linkTo: PropTypes.string,
	variant: PropTypes.string,
	adobeTrack: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(null)])
};

LinkTooltip.defaultProps = {
	btnLabel: '',
	tooltipLabel: '',
	linkTo: '',
	variant: 'primary',
	adobeTrack: null
};

export default LinkTooltip;
